export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Portal/index.js
// module id = 409
// module chunks = 2